<template>
  <div class="bread">
    <!-- 表格 -->
    <template v-if="tableData.length > 0">
      <div
        id="myChart"
        ref="chart"
        class="myChart"
        :style="{width: isMobile ? '353px' : '100%', height: isMobile ? (h + 'px') : '100%'}"
      ></div>
    </template>

    <template v-if="tableData.length === 0">
      <div class="nodata">
        <span>
          <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
          <div>暂无数据</div>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import macaronsDatas from './json/echartColor.json'
import { colorData } from './js/color.js';
import { hexToRGBA } from "@/api/utils";
import { echartTemp } from '@/components/common/echartsBuilder/template/breadDetails.js'
let chartsModel = "";
// var curInt = null;


export default {
  name: 'breadDetails',
  props: {
    h: Number,
    //- 分组字段数据
    row: {
      type: Array,
      default: () => []
    },
    //- 汇总字段数据
    summary: {
      type: Array,
      default: () => []
    },
    //- drage组件大小修改后，饼图实时更新
    changeSize: {
      type: Number,
      default: 0
    },
    //- 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    //- 表id
    id: {
      type: Number,
      default: 0
    },
    // 图形样式
    echartsTempId: {
      type: Number,
      default: -1
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean,
      default: () => false
    },
    viewShow: {
      type: Boolean,
      default: () => false
    },
    selectIndex: {
      type: Number,
      default: () => null
    },
    user: {
      type: Array,
      default: () => []
    },
    width: [String, Number],
    isMobile: {
      type: Boolean,
      default: false
    },
    // 是否门户或场景页
    isDoor: {
      type: Boolean,
      default: false
    },
    theme: Object
  },
  data: function () {
    return {
      myChart: '',
      nameArray: [],
      chartOption: {},
      echartsDataArr: [],
    }
  },
  mounted () {
    console.log("this.selectIndex==>", this.selectIndex);
    // if(this.selectIndex){
    //     curInt = this.selectIndex;
    // }
    this.$nextTick(() => {
      this.openFunBread();
    })
  },
  methods: {
    updateFun () {
      console.log("更新");
      if (this.myChart.resize) this.myChart.resize();
    },
    //- 打开图表
    openFunBread () {
      console.log("openFun", this.tableData.length);
      if (this.tableData.length <= 25 && this.tableData.length > 0) {
        this.$nextTick(() => {
          this.initData();
        })

      }

    },
    // series 值动态计算
    getSeries () {
      const series = []
      const seriesType = this.tableData[0].seriesType
      console.log(this.tableData,seriesType);
      if(seriesType === 'name'){
        this.echartsDataArr = this.tableData;
        if (this.theme && this.theme.axes && !this.isDoor) {
            const themeVal = this.theme
            series.push({
              data: this.tableData,
              type: 'pie',
              radius: '50%',
              center: ['50%', '60%'],
              labelLine: {
                show: false // 隐藏指示线
              },
              label: {
                show: false, // 隐藏标签
                formatter: function (param) {
                  const maxCharsPerLine = themeVal.singleCount != 0 ? themeVal.singleCount : 100;
                  const name = param.name;
                  // 包裹<a>标签的自动换行处理
                  let nameLines = [];
                  for (let i = 0; i < name.length; i += maxCharsPerLine) {
                      const line = name.substring(i, i + maxCharsPerLine);
                      nameLines.push(`{a|${line}}`);  // 每行包裹在a标签内
                  }
                  const wrappedName = nameLines.join('\n');  // 用换行符连接各行

                  // 构建数值部分的显示内容
                  let valueContent = '';
                  if (Array.isArray(themeVal.tagTextList)) {
                      if (themeVal.tagTextList.indexOf('value') !== -1) {
                          valueContent += param.value;
                      }
                      if (themeVal.tagTextList.indexOf('percent') !== -1) {
                          valueContent += `(${param.percent}%)`;
                      }
                  }

                  // 包裹<b>标签的数值显示
                  const valueDisplay = valueContent ? `{b|${valueContent}}` : '';
                  
                  // 组合最终结果（保持原有的双换行间距）
                  return wrappedName + '\n\n' + valueDisplay;
                },
              }
            })
          } else {
            series.push({
              data: this.tableData,
              type: 'pie',
              radius: '70%',
              center: ['50%', '60%'],
              labelLine: {
                show: false // 隐藏指示线
              },
              itemStyle: {
                borderWidth:3, //设置border的宽度有多大
                borderColor:'#fff',
                color: function (params) {
                  return colorData(params.dataIndex);
                }
              },
              label: {
                show: false, // 隐藏标签
                formatter: function (param) {
                  return param.name + '\n\n' + param.value + '(' + param.percent + '%)';
                },
              }
            })
          }
      }else{
        for (const i of this.summary) {
          const arr = this.tableData.map(its => {
            return {
              value: its[i.title],
              name: its.name
            }
          })
          this.echartsDataArr = arr;
          if (this.theme && this.theme.axes && !this.isDoor) {
            const themeVal = this.theme
            series.push({
              data: arr,
              type: 'pie',
              radius: '50%',
              center: ['50%', '60%'],
              labelLine: {
                show: this.theme.markTextShow || true
              },
              label: {
                show: this.theme.markTextShow || true,
                position: 'outside',    // 必须设为外部
                alignTo: 'edge',
                formatter: function (param) {
                  const maxCharsPerLine = themeVal.singleCount != 0 ? themeVal.singleCount : 100;
                  const name = param.name;
                  // 包裹<a>标签的自动换行处理
                  let nameLines = [];
                  for (let i = 0; i < name.length; i += maxCharsPerLine) {
                      const line = name.substring(i, i + maxCharsPerLine);
                      nameLines.push(`{a|${line}}`);  // 每行包裹在a标签内
                  }
                  const wrappedName = nameLines.join('\n');  // 用换行符连接各行

                  // 构建数值部分的显示内容
                  let valueContent = '';
                  if (Array.isArray(themeVal.tagTextList)) {
                      if (themeVal.tagTextList.indexOf('value') !== -1) {
                          valueContent += param.value;
                      }
                      if (themeVal.tagTextList.indexOf('percent') !== -1) {
                          valueContent += `(${param.percent}%)`;
                      }
                  }

                  // 包裹<b>标签的数值显示
                  const valueDisplay = valueContent ? `{b|${valueContent}}` : '';
                  
                  // 组合最终结果（保持原有的双换行间距）
                  return wrappedName + '\n\n' + valueDisplay;
                },
              }
            })
          } else {
            series.push({
              data: arr,
              type: 'pie',
              radius: '70%',
              center: ['50%', '60%'],
              labelLine: {
                show: true
              },
              itemStyle: {
                borderWidth:3, //设置border的宽度有多大
                borderColor:'#fff',
                color: function (params) {
                  return colorData(params.dataIndex);
                }
              },
              label: {
                show: true,
                formatter: function (param) {
                  return param.name + '\n\n' + param.value + '(' + param.percent + '%)';
                },
              }
            })
          }
        }
      }
      console.log('饼图series-->',series);
      return series
    },
    //- 创建图表
    initData () {
      console.log('创建图表获取主题配置数据', this.theme)
      const that = this;
      let nameArray = that.tableData.map(val => {
        return val.name
      })

      chartsModel = "";
      // that.tableData[0].selected = true;
      that.$nextTick(() => {
        // 基于准备好的dom，初始化echarts实例
        let dom = that.$refs.chart;
        if (!dom) return
        echarts.registerTheme('macarons', macaronsDatas.theme)
        chartsModel = echarts.init(dom, 'macarons');


        let opention = {
          tooltip: {
            trigger: 'item',
            formatter: "{b} : {c} ({d}%)"
          },
          legend: {
            type: 'scroll',
            top: 0,
            left: 'center',
            data: nameArray
          },
          grid: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            containLabel: true
          },
          series: this.getSeries()
/*
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: '70%',
              center: ['50%', '45%'],
              data: that.tableData,
              itemStyle: {
                borderWidth:3, //设置border的宽度有多大
                borderColor:'#fff',
                color: function (params) {
                  return colorData(params.dataIndex);
                }
              }
            }
          ]
*/
        };

        // 饼图不需要使用  axes 字段
        if (this.theme && this.theme.titleColor) {
          // 饼图的根据主题初始化
          const opentionNew = {
            series: this.getSeries(),
            color: this.theme.color,
/*
            series: [
              {
                type: 'pie',
                data: that.tableData,
                radius: '50%',
              }
            ],
*/
            legend: {
              type: 'scroll',
              top: '5px',
              left: 'right',
              data: nameArray,
              show: this.theme.legendTextShow || true,
              textStyle: {
                color: this.theme.legendTextColor || '#999999',
                fontSize: this.theme.legendTextFontSize || '14px',
                fontFamily: this.theme.legendTextFontFamily || 'simsun'
              }
            },
            tooltip: {
              trigger: 'item',
              backgroundColor: "rgba(255,255,255,0.95)", //设置背景图片 rgba格式
              textStyle: {
                color: "#333",
              },
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
            },

          }
          opentionNew.legend.top = this.theme.legendPosition || '5px'
          opention = {...opentionNew, ...this.theme}
          delete opention.axes
          delete opention.grid
          console.log('饼图配置', opention)
        }

        chartsModel.clear();
        // 绘制图表
        console.log("JSON.stringify(this.chartOption)==",JSON.stringify(this.chartOption));
        if(JSON.stringify(this.chartOption) === '{}' || this.chartOption === undefined){
          console.log("111");
          
          chartsModel.setOption(opention);
        }
        else{
          console.log("222");
          if(this.echartsTempId === 0){
            // 数据绑定
            const list = this.echartsDataArr;
            this.chartOption.color = this.theme.color
            this.chartOption.series[2].data = list
          }
          chartsModel.setOption(this.chartOption);
        }
        chartsModel.off("click");
        chartsModel.on("click", (param) => {
          //- 设置饼图点击事件
          if (that.isFrontEnd === true) {
            return;
          }
          // that.selectIndex = param.dataIndex;

          console.log("饼图点击事件=====>", param);

          that.relevanceFun(param.name, param.value, param.dataIndex);
        });
        that.myChart = chartsModel;
        that.$forceUpdate();
      })
    },
    //- 饼图点击事件，在客户端时候需要筛选查询该表单设置的对应关联表单
    relevanceFun (name, val, index) {
      if (this.isFrontEnd === true) {
        return;
      }
      let rowName = this.row[0].name;
      let summaryName = this.summary[0].name;
      let array = {};
      const nameArr = name ? name.split(/\1{1}/g) : name;
      if (Array.isArray(nameArr)) {
        for (let i = 0; i < this.row.length; i++) {
          array[this.row[i].name] = nameArr[i]
        }
      } else {
        array[rowName] = nameArr;
      }
      array[summaryName] = val;
      let date = {
        id: this.id,
        value: array,
        selectIndex: index
      }
      if (this.user[index]) date.user = this.user[index]
      this.$emit("relevanceFun", date)
    },
    // 主题切换,配色同时变化
    changeTheme(){
      if(this.echartsTempId === 0){
        const that = this;
        const themeVal = that.theme
        this.chartOption.series[2].itemStyle = {
          normal: {
            color: function (params) {
              const colorList = that.theme.color;
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 0,
                  color: hexToRGBA(colorList[params.dataIndex], '1')
                },
                {
                  offset: 1,
                  color: hexToRGBA(colorList[params.dataIndex], '0.6')
                },
              ]);
            },
          },
        }
        this.chartOption.series[2].label.normal.show = this.theme.markTextShow
        this.chartOption.series[2].label.normal.rich.a.color = this.theme.markTextColor
        this.chartOption.series[2].label.normal.rich.a.fontSize = this.theme.markTextFontSize
        this.chartOption.series[2].label.normal.rich.a.fontFamily = this.theme.markTextFontFamily
        this.chartOption.series[2].label.normal.rich.b.color = this.theme.tagTextColor
        this.chartOption.series[2].label.normal.rich.b.fontSize = this.theme.tagTextFontSize
        this.chartOption.series[2].label.normal.rich.b.fontFamily = this.theme.tagTextFontFamily
        this.chartOption.series[2].label.normal.formatter = function (param) {
          const maxCharsPerLine = themeVal.singleCount != 0 ? themeVal.singleCount : 100;
          const name = param.name;
          // 包裹<a>标签的自动换行处理
          let nameLines = [];
          for (let i = 0; i < name.length; i += maxCharsPerLine) {
              const line = name.substring(i, i + maxCharsPerLine);
              nameLines.push(`{a|${line}}`);  // 每行包裹在a标签内
          }
          const wrappedName = nameLines.join('\n');  // 用换行符连接各行

          // 构建数值部分的显示内容
          let valueContent = '';
          if (Array.isArray(themeVal.tagTextList)) {
              if (themeVal.tagTextList.indexOf('value') !== -1) {
                  valueContent += param.value;
              }
              if (themeVal.tagTextList.indexOf('percent') !== -1) {
                  valueContent += `(${param.percent}%)`;
              }
          }

          // 包裹<b>标签的数值显示
          const valueDisplay = valueContent ? `{b|${valueContent}}` : '';
          
          // 组合最终结果（保持原有的双换行间距）
          return wrappedName + '\n\n' + valueDisplay;
        }
      }
    },
  },
  watch: {
    changeSize (val) {
      console.log("w===>", val, this.tableData.length)
      if (this.tableData.length > 0) {
        setTimeout(() => {
          this.updateFun();

        }, 1000);

      }

    },
    'tableData': {
      handler (newV) {
        // do something, 可使用this
        // console.log(newV)
        if (newV && newV.length > 0) {
          this.$nextTick(() => {
            this.$forceUpdate();
            this.openFunBread();
          })
        }
      },
      deep: true
    },
    theme: {
      immediate: true,
      deep: true,
      handler () {
        console.log('配置更新')

        this.myChart = ''
        if(this.echartsTempId !== -1 && this.echartsTempId !== null){
          this.chartOption = echartTemp[this.echartsTempId]
          this.changeTheme()
        }
        // this.$forceUpdate();
        this.initData();
      },      
    },
    echartsTempId: {
      immediate: true,
      handler (val) {
        console.log('图形样式',val)
        if(val === -1){
          this.chartOption = {}
        }
        else{
          console.log("asdasddd");
          
          this.chartOption = echartTemp[val]
          if(val === 0){
            console.log("this.theme==",this.theme);
            this.changeTheme()
          }
        }
        this.initData();
      }
    },
    'selectIndex': {
      handler (newName) {
        console.log("变话了", newName)
        this.$nextTick(() => {
          this.$forceUpdate();
          this.initData();
        })
      },
      deep: true
    },
    viewShow: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    },
    width: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bread {
  width: 100%;
  height: 100%;
  // height: 91%;
  position: relative;
}
.nodata {
  width: 100%;
  text-align: center;
  color: #666666;
  height: 100%;
  position: relative;
  span {
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-left: -29px;
  }
}
</style>
